var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"dns-zone",attrs:{"outlined":"","hide-details":true,"value":_vm.valueData,"items":_vm.items,"item-text":"domain","item-value":"id","return-object":"","menu-props":{
    offsetY: true,
    nudgeBottom: '8px',
  }},model:{value:(_vm.valueData),callback:function ($$v) {_vm.valueData=$$v},expression:"valueData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }